import ItemsMenu from './ItemsMenu';
import React from 'react';
import { injectIntl } from 'react-intl';
import { inject } from 'mobx-react';

@inject('membersStore', 'rootStore')
@injectIntl
export default class Members extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { rootStore } = this.props;

    if (rootStore.modal)
      document.getElementById('igheader-tooltip-button').click();
  }

  render() {
    return (
      <div className="panel-fixed-height">
        <ItemsMenu items="mRoles" />
      </div>
    );
  }
}
